import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: 'loading',
    variantId: null,
    // quantity: null,
    subTotal: null,
    // totalDeliveryCharge: null,
    totalPayment: null
};

export const productBuyNowReducer = createSlice({
    name: "buyNow",
    initialState,
    reducers: {
        setProductBuyNow: (state, action) => {
            state.status = "fulfill";
            state.variantId = action.payload.variantId;
            // state.quantity = action.payload.quantity;
            state.subTotal = action.payload.subTotal;
            // state.totalDeliveryCharge = action.payload.totalDeliveryCharge;
            state.totalPayment = action.payload.totalPayment;
        }
    }
});

export const { setProductBuyNow } = productBuyNowReducer.actions;
export default productBuyNowReducer.reducer;